// extracted by mini-css-extract-plugin
module.exports = {"label":"VoteCount_label__3Jj7k","votes":"VoteCount_votes__32gBt"};